import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

const routeTitles = {
  '/home': 'HOME',
  '/customers': 'CUSTOMERS',
  '/customers/:id': 'CUSTOMER DETAILS',
  '/customers/import': 'CUSTOMERS',
  '/generate-invoice': 'GENERATE INVOICE',
  '/products': 'PRODUCTS',
  '/products/import': 'PRODUCTS',
  '/invoices': 'INVOICES',
  '/subscriptions': 'SUBSCRIPTIONS',
  '/subscriptions/edit/:id': 'EDIT SUBSCRIPTIONS',
  '/subscriptions/add': 'ADD SUBSCRIPTIONS',
  '/settings': 'SETTINGS',
  '/settings/invoice-configurations': 'INVOICE CONFIGURATION SETTINGS',
  '/settings/roles-permissions': 'ROLES AND PERMISSIONS SETTINGS',
  '/settings/profile': 'PROFILE',
  '/settings/avalara': 'AVALARA SETTINGS',

};

const getHeaderTitle = (pathname) => {
  let title = routeTitles[pathname] || 'Page';

  if (title === 'Page') {
    for (const pattern in routeTitles) {
      const regex = new RegExp(
        '^' + pattern
          .replace(/:[^/]+/g, '[^/]+')
          .replace(/\//g, '\\/') + '$'
      );
      
      if (regex.test(pathname)) {
        title = routeTitles[pattern];
      }
    }
  }
  return title;
};


// Helper: get the base route for current pathname
const getBaseRoute = (pathname) => {
  // Find matching base route keys
  const base = Object.keys(routeTitles).find((basePath) =>
    pathname === basePath || pathname.startsWith(basePath + '/')
  );
  return base || null;
};

// Helper: check if current path is a subpage (more segments than base)
const isSubpage = (pathname, baseRoute) => {
  if (!baseRoute) return false;

  // Count segments: split by / ignoring empty strings
  const pathSegments = pathname.split('/').filter(Boolean);
  const baseSegments = baseRoute.split('/').filter(Boolean);

  return pathSegments.length > baseSegments.length;
};

const PageHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const baseRoute = getBaseRoute(pathname);
  const title = baseRoute ? getHeaderTitle(pathname) : 'Page';
  const showBackButton = isSubpage(pathname, baseRoute);

  if (showBackButton) {
    return (
      <div className="subpage--title">
        <h2>{title}</h2>
        <Button
          type='text'
          onClick={() => navigate(baseRoute)}
          aria-label="Back to customers"
          icon={<LeftOutlined />}
          className='p-0'
        >
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <div className='page--title'>
      <h2>{title}</h2>
    </div>
  );
};

export default PageHeader;
